import styled from 'styled-components';
// import { Link } from 'gatsby';
// import activeClassName from 'gatsby-theme-pdv/src/layouts/nav/nav-item/active-classname';
import NavLink from 'gatsby-theme-pdv/src/layouts/nav/nav-item/nav-link';

export default styled(NavLink)`
  font-size: .8rem;
`;
